import { GridItem, Heading, Stack, Text } from '@chakra-ui/react'

import CollegePartnershipsLearnMoreButton from '@/components/Buttons/CollegePartnershipsLearnMoreButton'
import ShwGrid from '@/components/Layout/ShwGrid'

import CollegePartnerImage from './CollegePartnerImage'

const COL_SPAN = [12, 12, 6, 6]

export default function AboutCollegePartners() {
  return (
    <ShwGrid rowGap="40px" alignItems="center" my="48px">
      <GridItem colSpan={COL_SPAN} gridRow={{ base: 2, md: 1 }}>
        <Stack direction="column" spacing="16px">
          <Text variant="eyebrow">Our College Partners</Text>
          <Heading size="2xl">Boost your college applications.</Heading>
          <Text mb="8px">
            As colleges look for more data points in the applications process, Schoolhouse.world has
            partnered with schools to provide a new way to demonstrate readiness for college—via
            Schoolhouse portfolios that highlight certifications and tutoring experience.
          </Text>
          <CollegePartnershipsLearnMoreButton />
        </Stack>
      </GridItem>
      <GridItem colSpan={COL_SPAN} gridRow={{ base: 1, md: undefined }}>
        <CollegePartnerImage />
      </GridItem>
    </ShwGrid>
  )
}
